const getters = {
  getHelloVance(states) {
    return states.message + 'Vance';
  }
};
export default getters;
